<template>
  <ion-page>
    <master-layout pageTitle="لیست مشتریان">
        <ion-card-content>
          <router-link to="/Customer/Add" class="btn btn-success">افزودن مشتری جدید</router-link>
          <DataTable :card="true" auto-reload="1" v-if="route" :headers="headers" :route="route"></DataTable>
        </ion-card-content>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
   IonCardContent, IonPage
} from "@ionic/vue";


export default {
  data()
  {
    return {
      id: null,
      route:null,
      headers: [
        'نام کامل',
        'مانده حساب',
        'وضعیت',
        'منطقه',
        'پلن',
        'دسته بندی',
        'امکانات'
      ]
    };
  },
  async created()
  {
    this.route = 'Customer/listAjax';
  },
  components: {
     IonCardContent, DataTable, IonPage
  },
  watch: {
    // '$route.path': {
    //   handler(newUrl)
    //   {
    //     if (newUrl.indexOf('Customer/list') >= 0)
    //     {
    //       this.route = 'Customer/listAjax?t=' + (new Date().getTime())
    //     }
    //   }
    // }
  }
};
</script>

<style scoped>

</style>